<table [style.border-color]="lighterShade">
  <thead>
    <tr>
      @for (titleGroup of titleGroups; track titleGroup) {
        <th class="header" [attr.colspan]="titleGroup.span">
          {{ titleGroup.title }}
        </th>
      }
    </tr>
    <tr class="header">
      @for (title of titleArray; track title; let index = $index) {
        <th>
          @if (index === 0) {
            <span>&nbsp;</span>
          }
          {{ title }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (object of dataArray; track object; let tableIndex = $index) {
      <tr (click)="expand(tableIndex)">
        @for (field of object | keyvalue: originalOrder; track field; let index = $index) {
          <td class="values">
            @if (index === 0 && expandable) {
              <mat-icon class="expandable">{{
                expandedIndexes.includes(tableIndex) ? 'expand_more' : 'chevron_right'
              }}</mat-icon>
            }
          {{ field.value }}</td>
        }
      </tr>
      @if (expandedIndexes.includes(tableIndex)) {
        <tr style="background-color: white">
          <td [attr.colspan]="titleArray.length">
            @for (table of expandedTables[tableIndex]; track table) {
              <div>
                <table class="inner-table">
                  @for (titleRow of table.titles; track titleRow) {
                    <tr class="inner-header">
                      @for (title of titleRow; track title) {
                        <th [attr.colspan]="title.span" class="inner-header-cell">
                          {{ title.title }}
                        </th>
                      }
                    </tr>
                  }
                  <tr>
                    @for (data of table.data; track data) {
                      <td class="inner-cell">{{ data }}</td>
                    }
                  </tr>
                </table>
              </div>
            }
          </td>
        </tr>
      }
    }
    @if (useSummaryRow && dataArray.length > 0) {
      <tr class="sum-row">
        @for (field of summaryRowData | keyvalue: originalOrder; track field) {
          <td>{{ field.value }}</td>
        }
      </tr>
    }
  </tbody>
</table>
